import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import LeftColumn from '../layout/LeftColumn';
import SearchTabs from './SearchTabs';
import SmartcardCTA from '../smartcard/SmartcardCTA';

const SearchLeftColumn = ({ children, className = null, loading, title }) => {
    const baseClass = 'booking';
    return (
        <LeftColumn className={ cn(baseClass, className) } loading={ loading }>
            <SmartcardCTA />
            { title && (
                <h1 className={ cn(`${baseClass}__title`, 'sr-only') }>
                    { title }
                </h1>
            ) }
            <SearchTabs />
            { children }
        </LeftColumn>
    );
};

SearchLeftColumn.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    loading: PropTypes.bool,
    title: PropTypes.string,
};


export default SearchLeftColumn;



// WEBPACK FOOTER //
// ./src/components/search/LeftColumn.js